import React from 'react';
import { PopularCompany } from '../types/CompanyTypes';
import { getCompanyColor, formatSalaryRange } from '../utils/companyHelpers';
import StarIcon from '@mui/icons-material/Star';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';

interface CompanyCardProps {
  company: PopularCompany;
  onClick: (id: string) => void;
  darkMode?: boolean;
}

const CompanyCard: React.FC<CompanyCardProps> = ({ company, onClick, darkMode }) => {
  const color = getCompanyColor(company.id);

  return (
    <div
      className={`company-card ${darkMode ? 'dark' : ''}`}
      onClick={() => onClick(company.id)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && onClick(company.id)}
    >
      <div className="company-card-header">
        <div className="company-logo-placeholder" style={{ background: color }}>
          {company.name.charAt(0)}
        </div>
        <div className="company-card-info">
          <h3 className="company-card-name">{company.name}</h3>
          <span className="company-card-industry">{company.industry}</span>
        </div>
        <div className="company-rating">
          <StarIcon sx={{ fontSize: 16, color: '#f59e0b' }} />
          <span>{company.glassdoor_rating}</span>
        </div>
      </div>

      <div className="company-card-meta">
        <span className="meta-item">
          <LocationOnOutlinedIcon sx={{ fontSize: 16 }} />
          {company.headquarters}
        </span>
        <span className="meta-item">
          <PeopleOutlineIcon sx={{ fontSize: 16 }} />
          {company.employee_count}
        </span>
      </div>

      <div className="company-card-salary">
        {formatSalaryRange(company.salary_range.min, company.salary_range.max, company.salary_range.currency)}
      </div>

      <div className="company-card-tags">
        {company.tags.map(tag => (
          <span key={tag} className="company-tag">{tag}</span>
        ))}
      </div>
    </div>
  );
};

export default CompanyCard;
